import { gql } from 'apollo-boost';

/*export const allNotificationDeliveries = gql`
query {
  allNotificationDeliveries {
    edges {
        node {
            dbId
            rule
            recipient
            deliveryStatus
            recipientName
            recipientEmail
            portfolioName
            ruleName
            date
            template
            email
            npo {
              name
            }
            program {
              name
              logoFileUrl
            }
            investment
        }
    }
  }
}
`;*/

export const allNotificationDeliveries = gql`
query ($top: Int, $offset: Int) {
  allNotificationDeliveries (first: $top, offset: $offset) {
    edges {
      node {
        dbId
        rule
        recipient
        deliveryStatus
        recipientName
        recipientEmail
        portfolioName
        ruleName
        date
        template
        email
        npo {
          name
        }
        program {
          name
          logoFileUrl
        }
        investment
      }
    }
  }
}
`;
